import React, { useState, useEffect } from "react";
import TeacherMenu from "./TeacherMenu";
import ShowStaff from "../Shared/ShowStaff";
import { scrollToTop } from "../Shared/ScrollOnTop";
import { NavLink } from "react-router-dom";
import axios from "axios";
import config from "../../Config";
import moment from "moment";

function TeacherDashboard(props) {
  const [AccessKey, setAccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID, setUserID] = useState(localStorage.getItem("ID"));
  const [MemberType, setMemberType] = useState(
    localStorage.getItem("MemberType")
  );
  const [events, setEvents] = useState([]);
  const [eventsLoading, setEventsLoading] = useState(true);

  useEffect(() => {
    axios({
      method: "post",
      url: config.base_url + "SchoolEvent/GetEventsForStaffDashboard",
      headers: { "Content-Type": "application/json" },
      data: {
        AccessKey,
        UserID: parseInt(UserID, 10) || 0,
        MemberType: MemberType || "Teacher",
        pageNo: 1,
        pageSize: 5,
      },
    })
      .then((res) => setEvents(res.data.ListofRecords || []))
      .catch(() => {})
      .finally(() => setEventsLoading(false));
  }, []);

  return (
    <>
      <TeacherMenu />
      <div className=" body-content">
        <div className="page-head">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-6">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <NavLink to="/teacher/Dashboard">Home</NavLink>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Teacher Dashboard
                    </li>
                  </ol>
                </nav>
                <div className="page-title">Teacher Dashboard</div>
              </div>
            </div>
          </div>
        </div>
        <div className="page-content">
          <ShowStaff EmployeeID={UserID} />
          <div className="container">
            <div className="card mb-3">
              <div className="card-body">
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <b>School Events</b>
                  <NavLink to="/teacher/events">View all</NavLink>
                </div>
                {eventsLoading ? (
                  <p className="text-muted mb-0">Loading events...</p>
                ) : events.length === 0 ? (
                  <p className="text-muted mb-0">No approved events.</p>
                ) : (
                  <ul className="mb-0">
                    {events.map((e) => (
                      <li key={e.ID}>
                        {e.EventTitle} ({moment(e.StartDate).format("DD MMM")})
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </div>
            <div className="card mb-3">
              <div className="card-body">
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <b>Class Time Table</b>
                  <NavLink to="/teacher/timetable">Open</NavLink>
                </div>
                <p className="text-muted mb-0">View your active teaching timetable by day and period.</p>
              </div>
            </div>
            <div className="card">
              <div className="card-body">
                <div className="row">
                  <div className="col-md-12">
                    <b>Leaves in this Month</b>
                  </div>
                  <div className="col-md-12">
                    <table className="table table-theme">
                      <thead>
                        <tr>
                          <th>ID</th>
                          <th>Staff Name</th>
                          <th>Description</th>
                          <th>Amount</th>
                        </tr>
                      </thead>
                      <tbody></tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default TeacherDashboard;
